import actions from "@/store/modules/synthetics/applications/applications.action";
import getters from "@/store/modules/synthetics/applications/applications.getters";
import mutations from '@/store/modules/synthetics/applications/applications.mutation';
export interface State {
  currentTemplate: any;
  templateMetrics: any[];
  currentEventItem: any;
  currentEventID: any;
  chartTemplate: any;
}

const initialState: State = {
  currentTemplate: {},
  templateMetrics: [],
  currentEventItem: {},
  currentEventID: {},
  chartTemplate: []
};

export default {
  namespaced: true,
  actions: actions,
  state: initialState,
  getters: getters,
  mutations: mutations,
};
